// src/pages/ContactPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faGoogle } from '@fortawesome/free-brands-svg-icons';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import '../styles/ContactPage.css';

const ContactPage = () => (
  <div className="contact-page">
    <div className="contact-layout">

      {/* ── Left: info ── */}
      <div>
        <span className="contact-info__eyebrow">Get in Touch</span>
        <h1 className="contact-info__title">Contact Us</h1>
        <p className="contact-info__sub">
          Whether you have a question, want to make a special request, or just want to
          say hello — we'd love to hear from you.
        </p>

        <div className="contact-details">
          <div className="contact-detail">
            <span className="contact-detail__icon" aria-hidden="true">📍</span>
            <div className="contact-detail__text">
              <strong>Address</strong>
              30 Victoria Street, #01-31 CHIJMES<br />Singapore 187996
            </div>
          </div>
          <div className="contact-detail">
            <span className="contact-detail__icon" aria-hidden="true">📞</span>
            <div className="contact-detail__text">
              <strong>Phone / WhatsApp</strong>
              <a href="tel:+6590079953">+65 9007 9953</a>
            </div>
          </div>
          <div className="contact-detail">
            <span className="contact-detail__icon" aria-hidden="true">✉️</span>
            <div className="contact-detail__text">
              <strong>Email</strong>
              <a href="mailto:lebua.thai@gmail.com">lebua.thai@gmail.com</a>
            </div>
          </div>
          <div className="contact-detail">
            <span className="contact-detail__icon" aria-hidden="true">🕐</span>
            <div className="contact-detail__text">
              <strong>Opening Hours</strong>
              Monday – Sunday: 11:30 AM – 3:00 PM &amp; 5:30 PM – 11:00 PM<br />Last Orders: 10:00 PM
            </div>
          </div>
        </div>

        <div className="contact-social">
          <a href="https://www.facebook.com/profile.php?id=61556215584916" className="contact-social__link" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://www.instagram.com/lebua_thai/" className="contact-social__link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://g.co/kgs/Ct72hTQ" className="contact-social__link" target="_blank" rel="noopener noreferrer" aria-label="Google">
            <FontAwesomeIcon icon={faGoogle} />
          </a>
        </div>
      </div>

      {/* ── Right: form ── */}
      <div className="contact-form-wrap">
        <h2>Send a Message</h2>
        <p>We'll get back to you as soon as possible.</p>
        <ContactForm />
      </div>

    </div>
    <Footer />
  </div>
);

export default ContactPage;
